var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemindCvReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.241,
    height: 16,
    viewBox: "0 0 13.241 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659",
    transform: "translate(1895 -9087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rewind-30",
    transform: "translate(-1895 9087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M24,15.379a6.621,6.621,0,1,0,6.621-6.621H28.414V6L25.1,9.31l3.31,3.31V9.862h2.207A5.517,5.517,0,1,1,25.1,15.379Z",
    transform: "translate(-24 -6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "notifications-none",
    transform: "translate(-1891.907 9092.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M3.489,9.51a.787.787,0,0,1-.577-.24.776.776,0,0,1-.24-.567H4.306a.776.776,0,0,1-.24.567A.787.787,0,0,1,3.489,9.51ZM6.152,7.049l.827.827v.4H0v-.4l.827-.827V4.8A2.586,2.586,0,0,1,1.4,3.137,2.6,2.6,0,0,1,2.865,2.2V1.935a.582.582,0,0,1,.183-.442.62.62,0,0,1,.442-.173.587.587,0,0,1,.433.173.6.6,0,0,1,.173.442V2.2a2.6,2.6,0,0,1,1.48.932A2.586,2.586,0,0,1,6.152,4.8Zm-.827.423V4.8A1.838,1.838,0,0,0,3.48,2.954a1.78,1.78,0,0,0-1.307.538A1.78,1.78,0,0,0,1.634,4.8V7.472Z",
    transform: "translate(0 -1.32)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemindCvReview);
export default __webpack_public_path__ + "static/media/Remind CV Review.43f0cc5b36b99758566d0cd30c5df52d.svg";
export { ForwardRef as ReactComponent };